import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

/**
 * FIREBASE AUTH & THIRD-PARTY COOKIES (FIX)
 * 
 * Chrome is deprecating third-party cookies. To prevent login issues:
 * 1. Go to Firebase Console > Authentication > Settings > Authorized Domains.
 * 2. Add your custom domain (e.g., auth.eduexpertai.com).
 * 3. Update the 'authDomain' below to your custom domain.
 * 
 * This change turns 'third-party' cookies into 'first-party' cookies, 
 * resolving the 37+ cookie warnings and ensuring future stability.
 */

const firebaseConfig = {
  apiKey: 'AIzaSyCojipaTc7_tHoP9-XSvxHhS0f6V9Z0uII',
  // Default: 'ai-online-examination.firebaseapp.com'
  // RECOMMENDED: Set this to your custom domain (e.g., 'auth.eduexpertai.com') 
  // after configuring it in the Firebase Console and your DNS.
  authDomain: 'ai-online-examination.firebaseapp.com', 
  projectId: 'ai-online-examination',
  storageBucket: 'ai-online-examination.firebasestorage.app',
  messagingSenderId: '503413669502',
  appId: '1:503413669502:web:a0324b38be52e8ecd8622f',
  measurementId: 'G-TXRR1SLGYP',
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Configure Google Provider
const provider = new GoogleAuthProvider();
// Optional: Use FedCM if supported (available in newer Firebase versions)
// auth.config.experimental.enableFedCM = true; 

const signInWithGoogle = async () => {
  try {
    // signInWithPopup is compatible with the fix as long as authDomain is configured correctly.
    const result = await signInWithPopup(auth, provider);
    const token = await result.user.getIdToken(); 
    return { token, result };
  } catch (error) {
    console.error("Firebase Google Auth Error:", error);
    throw error;
  }
};

export { auth, signInWithGoogle };

